export const VERIFICATION_STATUSES = [
  // 'pending',
  'unverified'
  // 'verified'
];
